// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2fTG8","rootNoMargin":"styles_rootNoMargin__NZ5JL"};